/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Home_V2_Filter_TriggerInputs */

const en_home_v2_filter_trigger = /** @type {(inputs: Home_V2_Filter_TriggerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Filters: ${i?.type}`)
};

const es_home_v2_filter_trigger = /** @type {(inputs: Home_V2_Filter_TriggerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Filtros: ${i?.type}`)
};

/**
* | output |
* | --- |
* | "Filters: {type}" |
*
* @param {Home_V2_Filter_TriggerInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const home_v2_filter_trigger = /** @type {((inputs: Home_V2_Filter_TriggerInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_V2_Filter_TriggerInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_v2_filter_trigger(inputs)
	return en_home_v2_filter_trigger(inputs)
});